import { IconName, Text } from '@billy/design-system'
import { TFunction } from 'i18next'
import { ReactNode } from 'react'

import { EmberRoute } from '../../../../../enums/emberRoute'
import { Scope } from '../../../../../enums/scope'
import { NavigationMenuLabel } from '../elements/NavigationMenuLabel'
import { NavigationMenuItem } from '../types/NavigationMenuItem'
import { NavigationMenuItemId } from '../types/NavigationMenuItemId'
import { hasSubItems } from './hasSubItems'
import { transformRouteToUrl } from './transformRouteToUrl'

interface TransformItemsStructureArgs {
  menuItems: NavigationMenuItem[]
  organizationUrl?: string
  convertEmberRouteToUrl: (route: EmberRoute) => string
  t: TFunction
}

export interface TransformItemsStructure {
  id: NavigationMenuItemId
  iconLeft?: IconName
  children: ReactNode
  to: string
  value: string
  scopes?: Scope[] | Scope
  subItems?: TransformItemsStructure[]
  title: string
}

export const transformItemsStructure = ({
  menuItems,
  organizationUrl,
  convertEmberRouteToUrl,
  t,
}: TransformItemsStructureArgs) => {
  return menuItems.map((item): TransformItemsStructure => {
    if (hasSubItems(item)) {
      const firstSubItem = item.subItems[0]

      return {
        id: item.id,
        iconLeft: item.iconLeft,
        children: <Text weight="bold">{t(item.label)}</Text>,
        to: transformRouteToUrl({
          id: firstSubItem.id,
          convertEmberRouteToUrl,
          organizationUrl,
          route: firstSubItem.to,
        }),
        title: t(item.label),
        value: firstSubItem.to,
        subItems: item.subItems.map((subItem) => ({
          id: subItem.id,
          scopes: subItem.scopes,
          children: <NavigationMenuLabel label={t(subItem.label)} badge={subItem?.badge} wrap={subItem.wrap} />,
          to: transformRouteToUrl({
            id: subItem.id,
            convertEmberRouteToUrl,
            organizationUrl,
            route: subItem.to,
          }),
          title: t(subItem.label),
          value: subItem.to,
        })),
      }
    }

    return {
      id: item.id,
      scopes: item.scopes,
      iconLeft: item.iconLeft,
      children: <NavigationMenuLabel label={t(item.label)} badge={item?.badge} isNotSubItem={true} wrap={item.wrap} />,
      to: transformRouteToUrl({
        id: item.id,
        convertEmberRouteToUrl,
        organizationUrl,
        route: item.to,
      }),
      title: t(item.label),
      value: item.to,
    }
  })
}
